import { useAtomValue } from 'jotai';

import { isScreenSharingAtom } from '../../video-sdk';
import { StopScreenShareButton } from './StopScreenShareButton';
import useScreenShareCallbacks from './useScreenShareCallbacks';

export function StopScreenShareButtonWrapper() {
  const isSharing = useAtomValue(isScreenSharingAtom);
  const { stopScreenShare } = useScreenShareCallbacks();

  if (!isSharing) return null;

  return <StopScreenShareButton onClick={stopScreenShare} />;
}
